module.exports = __webpack_public_path__ + "img/promoter.bcc2a526.png";